module.exports = __webpack_public_path__ + "static/img/wealth_level_93.b9c53f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/level/wealth_level_93.png
// module id = zWEE
// module chunks = 0